import {Controller, useFieldArray, useFormContext} from "react-hook-form";
import {ServiceOrderDeliverWorkFormValues} from "../schema-validation";
import {Button, Input, Space} from "antd";
import {CloseOutlined, DeleteOutlined, PlusCircleFilled} from "@ant-design/icons";
import {FormFieldError} from "../../../../../design-system/form-field";

export function StoreServiceOrderDeliverWorkFormCompletedWorkLinks() {
  const {control} = useFormContext<ServiceOrderDeliverWorkFormValues>();
  const {fields, append, remove} = useFieldArray({
    control,
    name: "completedWorkLinks",
  });
  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <Space size={8} direction="vertical" style={{display: "flex"}}>
          <p>Paste the link to your completed work</p>
          <Space size={8} direction="vertical" style={{display: "flex"}}>
            {fields.slice(0, 5).map((item, index) => (
              <div key={item.id} style={{display: "flex", gap: "1.6rem"}}>
                <div style={{flex: "1"}}>
                  <Controller
                    control={control}
                    name={`completedWorkLinks.${index}.link`}
                    render={({
                      field: {onChange, value, ref, onBlur},
                      fieldState: {error},
                    }) => (
                      <Space size={8} direction="vertical" style={{display: "flex"}}>
                        <Input
                          // id={id}
                          status={error?.message ? "error" : ""}
                          onChange={onChange}
                          onBlur={onBlur}
                          size="large"
                          value={value === null ? undefined : value}
                          placeholder="Enter a valid URL"
                          ref={ref}
                        />
                        <FormFieldError errorMessage={error?.message} />
                      </Space>
                    )}
                  />
                </div>
                {index > 0 && (
                  <Button
                    onClick={() => remove(index)}
                    type="link"
                    shape="circle"
                    icon={<DeleteOutlined />}
                    size="small"
                  />
                )}
              </div>
            ))}
          </Space>
          <p
            style={{
              color: "#595959",
              fontSize: "1.2rem",
            }}
          >
            You can add a link to Google Drive, Drop box, or any online resource that
            gives your customer access to the final delivery.
          </p>
        </Space>
        <Button
          size="small"
          disabled={fields.length >= 5}
          icon={<PlusCircleFilled />}
          onClick={() => {
            append({
              link: "",
            });
          }}
        >
          Add link
        </Button>
      </Space>
    </div>
  );
}
